module.exports = __webpack_public_path__ + "img/Flag_of_Brazil.3243009d.svg";